import { render, staticRenderFns } from "./EntityReationshipDataTable.vue?vue&type=template&id=1b21adbd&scoped=true"
import script from "./EntityReationshipDataTable.vue?vue&type=script&lang=js"
export * from "./EntityReationshipDataTable.vue?vue&type=script&lang=js"
import style0 from "./EntityReationshipDataTable.vue?vue&type=style&index=0&id=1b21adbd&prod&lang=scss&scoped=true"
import style1 from "./EntityReationshipDataTable.vue?vue&type=style&index=1&id=1b21adbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b21adbd",
  null
  
)

export default component.exports